import { render, staticRenderFns } from "./salary-detail.vue?vue&type=template&id=7c6307d6&scoped=true&"
import script from "./salary-detail.vue?vue&type=script&lang=js&"
export * from "./salary-detail.vue?vue&type=script&lang=js&"
import style0 from "./salary-detail.vue?vue&type=style&index=0&id=7c6307d6&scoped=true&lang=css&"
import style1 from "./salary-detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6307d6",
  null
  
)

export default component.exports